<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Lieferschein
          </v-card-title>
          <v-card-text>
            <v-spacer />
            <v-form v-model="valid" @submit.prevent="create()">
              <v-divider class="mb-1" />
              <v-text-field v-model="deliveryReceiptNumber" outlined :rules="[v => !!v || 'Item is required']" required label="Lieferschein Nummer" />
              <v-autocomplete
                v-model="warehouse"
                class="mb-3"
                :items="warehouses"
                item-text="name"
                item-value="id"
                label="Warenlager"
                outlined
              />
              <div v-for="(item, key) in deliveryReceipt" :key="key">
                <v-spacer :key="key" class="my-2" />
                <v-card>
                  <v-card-title>
                    {{ item.name }}
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="6" lg="4">
                        <h4>Soll Menge: {{ item.amount }}</h4>
                        <h4>Liefer Menge: {{ getAmount[key] }}</h4>
                      </v-col>
                      <v-col class="mt-3" cols="12" md="6" lg="8">
                        <v-combobox
                          v-model="item.serialCodes"
                          label="Serienummern"
                          multiple
                          chips
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
              <div class="d-flex justify-end">
                <v-btn :disabled="!valid" color="primary" type="submit" class="mt-3">
                  ANLEGEN
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
export default {
   name: 'IncomingIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : 'Lieferschein Bestellung - ' + this.purchase.invoice_number,
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      purchase: {
         type: Object,
         required: true
      },
      purchaseItemData: {
         type: Array,
         required: true
      },
      warehouses: {
         type: Array,
         required: true,
      }
   },
   data () {
      return {
         deliveryReceipt: [],
         valid: true,
         deliveryReceiptNumber: null,
         warehouse: null
      }
   },
   computed: {
      getAmount: function () {
         const amount = []
         this.deliveryReceipt.forEach((item, i) => {
            amount[i] = item.serialCodes.length
         })
         return amount
      }
   },
   mounted () {
      this.createDeliveryReceipt()
   },
   methods: {

      createDeliveryReceipt () {
         this.purchaseItemData.forEach(item => {
            this.deliveryReceipt.push(
               {
                  name: item.name,
                  amount: item.amount,
                  purchase_item_data_id: item.purchase_item_data_id,
                  serialCodes: []
               }
            )
         })
      },
      create () {
         if (this.deliveryReceiptNumber !== null && this.deliveryReceiptNumber !== '') {
            const toSubmit = {
               warehouse: this.warehouse,
               purchase: this.purchase,
               deliveryReceiptNumber: this.deliveryReceiptNumber,
               items: this.deliveryReceipt
            }
            this.$inertia.post(this.route('delivery_receipt.store'), toSubmit)
         }
      }
   }
}
</script>

<style>

</style>
